import { render, staticRenderFns } from "./M60SDomesticHeatmap.vue?vue&type=template&id=368eb6e0&scoped=true&"
import script from "./M60SDomesticHeatmap.vue?vue&type=script&lang=js&"
export * from "./M60SDomesticHeatmap.vue?vue&type=script&lang=js&"
import style0 from "./M60SDomesticHeatmap.vue?vue&type=style&index=0&id=368eb6e0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368eb6e0",
  null
  
)

export default component.exports